import type { ComponentProps } from "react";
import { DateField } from "@apac/core-form-ui";

export const BirthDateField = (props: ComponentProps<typeof DateField>) => {
  return <DateField {...props} />;
};
